import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-loading-dashboard-dialog',
  templateUrl: './loading-dashboard-dialog.component.html',
  styleUrls: ['./loading-dashboard-dialog.component.scss'],
})
export class LoadingDashboardDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
  onReload() {
    // window.location.reload();
  }
}
